import { useRef, useState } from "react";
import "./RotatingToggler.css";
import { Navbar } from "react-bootstrap";

export default function RotatingToggler() {
  const btnRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  const toggleFocus = () => {
    if (isFocused) {
      // Remove focus
      btnRef.current.blur();
      setIsFocused(false);
    } else {
      // Apply focus
      btnRef.current.focus();
      setIsFocused(true);
    }
  };

  return (
    <Navbar.Toggle
      aria-controls="main-navbar"
      ref={btnRef}
      className="rotating-toggler"
      onClick={toggleFocus}
    >
      <span></span>
      <span></span>
      <span></span>
    </Navbar.Toggle>
  );
}
